'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _package = require('../../package.json');

exports["default"] = _package.version;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./components/version/index.tsx
 ** module id = 375
 ** module chunks = 0 1
 **/